const resources = {
    lead: 'Sign in for a more personalized experience',
    signIn: 'Sign In',
    createAccount: 'Create Account'
};

module.exports = function getResource(label) {
    return resources[label];
};
